<template>
  <v-dialog
    :value="visiblePopup"
    :max-width="980"
    @click:outside="onNoClickButton"
    @keydown.esc="onNoClickButton"
  >
    <v-card class="popup-wrapper">
      <div class="title">{{$t(title)}}</div>
      <div class='compliance-wrapper'>
        <v-chip-group
          active-class='primary--text'
          column
          multiple
          :key="visiblePopup"
        >
          <v-chip
            v-for="(compliance, index) in complianceValues"
            :key="index"
            @click='addChip(compliance)'
            :class="[mapComplianceColor(compliance)]"
            class='compliance'
          >
            {{ compliance }}
          </v-chip>
        </v-chip-group>
      </div>
      <div class="buttons">
        <v-btn v-if='showNoButton' small depressed class="no-button btn-secondary" @click="onNoClickButton()">
          {{$t(noCaption)}}
        </v-btn>
        <v-btn small depressed class="yes-button btn-primary" @click="onYesClickButton()" :disabled='saveDisabled'>
          {{$t(yesCaption)}}
        </v-btn>
      </div>
    </v-card>
  </v-dialog>

</template>

<script>

import { mapGetters } from 'vuex';
import disableOuterScrollOnPopupVisible from '@/mixins/disableOuterScrollOnPopupVisible';

export default {
  name: 'SelectCompliancePopup',
  mixins: [disableOuterScrollOnPopupVisible],
  props: {
    title: String,
    yesCaption: String,
    noCaption: String,
    showNoButton: {
      type: Boolean,
      default: true,
      required: false,
    },
    visiblePopup: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      selectedCompliance: [],
    };
  },
  methods: {
    onYesClickButton() {
      this.$emit('clicked', this.selectedCompliance);
      this.selectedCompliance = [];
    },
    onNoClickButton() {
      this.$emit('clicked', false);
      this.selectedCompliance = [];
    },
    addChip(compliance) {
      if (this.selectedCompliance.includes(compliance)) {
        this.selectedCompliance = this.selectedCompliance.filter(item => item !== compliance);
      } else {
        this.selectedCompliance.push(compliance);
      }
    },
    mapComplianceColor(compliance) {
      if (this.complianceValuesByStatus.FAIL.includes(compliance)) {
        return 'fail';
      }
      return '';
    },
  },
  computed: {
    ...mapGetters([
      'configurationServicesAssets',
      'configurationServicesComplianceOptions',
    ]),
    saveDisabled() {
      return this.selectedCompliance.length === 0;
    },
    complianceValues() {
      return Array.from(new Set([...this.complianceValuesByStatus?.INFO, ...this.complianceValuesByStatus?.PASS, ...this.complianceValuesByStatus?.FAIL])).sort();
    },
    complianceValuesByStatus() {
      const complianceValues = {
        INFO: [],
        FAIL: [],
        PASS: [],
      };
      if (this.configurationServicesComplianceOptions) {
        if (this.configurationServicesComplianceOptions.FAIL && this.configurationServicesComplianceOptions.FAIL.length > 0) {
          complianceValues.FAIL = this.configurationServicesComplianceOptions.FAIL;
        }
        if (this.configurationServicesComplianceOptions.PASS && this.configurationServicesComplianceOptions.PASS.length > 0) {
          this.configurationServicesComplianceOptions.PASS.forEach(item => {
            if (!complianceValues.FAIL.includes(item)) {
              complianceValues.PASS.push(item);
            }
          });
        }
        if (this.configurationServicesComplianceOptions.INFO && this.configurationServicesComplianceOptions.INFO.length > 0) {
          this.configurationServicesComplianceOptions.INFO.forEach(item => {
            if (!complianceValues.FAIL.includes(item) && !complianceValues.PASS.includes(item)) {
              complianceValues.INFO.push(item);
            }
          });
        }
      }
      return complianceValues;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/design-system';

.popup-wrapper {
  max-width: rem(980);
  min-width: rem(980);
  padding: $space-8 $space-10;

  .compliance-wrapper {
    margin-bottom: rem(-20);

    .compliance {
      margin-bottom: $space-1-5;
      background: $severity-low-bg;
      color: var(--severity-low);

      &.fail {
        background: $severity-critical-bg;
        color: var(--severity-critical);
      }
    }
  }

  .title {
    color: var(--text-primary);
    font-size: $font-size-base;
    font-weight: 600;
    letter-spacing: 1.12px;
    line-height: $space-4;
    text-transform: uppercase;
    padding-bottom: $space-6;
  }

  .buttons {
    text-align: right;
    padding-top: $space-7;

    .no-button {
      box-sizing: border-box;
      height: $btn-height-md;
      width: rem(86);
      border: $border-width-thin solid var(--brand-primary);
      color: var(--brand-primary);
      border-radius: $radius-sm;
      background-color: var(--bg-primary);
      box-shadow: $shadow-sm;
    }

    .yes-button {
      height: $btn-height-md;
      width: rem(51);
      border-radius: $radius-sm;
      box-shadow: $shadow-sm;
      font-size: $font-size-sm;
      font-weight: 500;
      letter-spacing: 1.07px;
      line-height: $space-4;
      text-align: center;
      margin-left: $space-2;
    }
  }
}
</style>
